import { TextField, TextFieldProps } from "@mui/material";

export default function StyledTextField(props: TextFieldProps) {
  return (
    <TextField
      size="small"
      margin="normal"
      variant="outlined"
      {...props}
      sx={{
        "& .MuiFormHelperText-root": {
          marginTop: "2px",
          position: "absolute",
        },
        "& .MuiInputBase-root": {
          minHeight: "40px",
        },
        "& .MuiInputBase-input": {
          height: "20px",
          boxSizing: "border-box",
          padding: "8px 12px",
          textTransform: "uppercase",
          fontSize: 14,
        },
        "& .MuiFormHelperText-root.Mui-error": {
          position: "absolute",
          bottom: "-22px",
        },
        mb: 3,
        ...props.sx,
      }}
    />
  );
}
